module.exports = __webpack_public_path__ + "static/media/skullcandy-ink'd-bluetooth.19616e8f.jpg";